import React from 'react';
import { TextInput } from 'hyperdb-utils';
import { CountrySelector } from '../../country';

export default class AddressForm extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const countryId = this.props.address.country ? this.props.address.country.value[1] : null;
    return (
    <fieldset>
      <legend>Address</legend>
      <TextInput
        label="Line 1"
        name="line1"
        value={ this.props.address.line1 }
        onChange={ this.handleChange.bind(this, 'line1') }
      />
      <TextInput
        label="Line 2"
        name="line2"
        value={ this.props.address.line2 }
        onChange={ this.handleChange.bind(this, 'line2') }
      />
      <TextInput
        label="Line 3"
        name="line3"
        value={ this.props.address.line3 }
        onChange={ this.handleChange.bind(this, 'line3') }
      />
      <TextInput
        label="Postcode"
        name="postcode"
        value={ this.props.address.postcode }
        onChange={ this.handleChange.bind(this, 'postcode') }
      />
      <TextInput
        label="City"
        name="city"
        value={ this.props.address.city }
        onChange={ this.handleChange.bind(this, 'city') }
      />
      <CountrySelector value={ countryId } onChange={ this.handleChangeRelation.bind(this, 'country') } required={ this.props.mode === 'customer' } />
    </fieldset>
    );
  }

  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.onChange({ ...this.props.address, [attributeName]: value });
  }
  handleChangeRelation(attributeName, field) {
    const { name, value } = field;
    const relation = { ...this.props.address[attributeName] || { $type: 'reference', external: true, value: ['countries'] } };
    relation.value[1] = value;
    this.handleChange(attributeName, { value: relation });
  }
}

AddressForm.propTypes = {
  address: React.PropTypes.object,
  onChange: React.PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/address-book/address/components/AddressForm.jsx